module.exports = __webpack_public_path__ + "img/Boucherie_3.297b503f.jpg";